// @flow
import React from "react";

type Position = "left" | "right";

interface InfoProps {
	title: string;
	body: string;
	position?: Position;
}

const Info = ({ title, body, position }: InfoProps) => (
	<div className={position + " info"}>
		<span>{title}</span>
		<h4 className="code-info">{body}</h4>
	</div>
);

export default Info;
